export default __webpack_public_path__ + "static/Entenda0032-df843e1de729e8a0513059c682bb3695.jpg";